import { trpc } from "@/lib/trpc";
import { toast } from "sonner";
import { fromError } from "zod-validation-error";

export const useUserMutation = (
    setOpen: (open: boolean) => void,
    userId?: string,
    setLoading?: (loading: boolean) => void,
    setError?: (error: string) => void
) => {
    const utils = trpc.useUtils();
    const mutationFn = userId ? trpc.users.update : trpc.users.create;
    return mutationFn.useMutation({
        onMutate: async () => {
            if (setLoading) setLoading(true);
            if (setError) setError("");
        },
        onSuccess: async () => {
            utils.users.findMany.invalidate();
            utils.users.findOne.invalidate({ id: userId });
            setOpen(false);
            toast.success(userId ? "User updated successfully" : "User created successfully");
        },
        onError: async (error: any) => {
            return setError && setError(fromError(error.message).toString());
        },
        onSettled: async () => {
            return setLoading && setLoading(false);
        },
    });
};

export const useDeleteUserMutation = (ids: string[]) => {
    const utils = trpc.useUtils();
    return trpc.users.remove.useMutation({
        onSuccess: async () => {
            utils.users.findMany.invalidate();
            ids.forEach((id) => {
                utils.users.findMany.invalidate();
                utils.users.findOne.invalidate({ id });
            });
            toast.success(`User${ids.length > 1 ? "s" : ""} deleted successfully`);
        },
    });
};
